module.exports = __webpack_public_path__ + "static/images/styles/images/challenges/icon-superiority.a9a049dd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/challenges/icon-superiority.png
// module id = 3615
// module chunks = 11